export interface DebugProps {
  visible: boolean;
  state: unknown;
}

export function Debug(props: DebugProps) {
  return props.visible ? (
    <pre className="bg-gray-300 text-xs">
      {JSON.stringify(props.state, null, 2)}
    </pre>
  ) : (
    <div />
  );
}

export default Debug;
